import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  PrintSample,
  PrintSampleListParams,
  PrintSamplePayload,
  PrintSampleScope,
} from "./types";

export const printSampleListService = (
  scope: PrintSampleScope,
  params: PrintSampleListParams
) =>
  RestAPIClient.call<RestAPIResponseList<PrintSample>>({
    method: HTTPRequestMethods.GET,
    url: Paths[scope],
    config: { requireAuthentication: true, params },
  });

export const printSampleCreateService = (
  scope: PrintSampleScope,
  data: PrintSamplePayload
) =>
  RestAPIClient.call<PrintSample>({
    method: HTTPRequestMethods.POST,
    url: Paths[scope],
    config: { requireAuthentication: true },
    data,
  });

export const printSampleDetailService = (scope: PrintSampleScope, id: string) =>
  RestAPIClient.call<PrintSample>({
    method: HTTPRequestMethods.GET,
    url: `${Paths[scope]}/${id}`,
    config: { requireAuthentication: true },
  });

export const printSampleUpdateService = (
  scope: PrintSampleScope,
  id: string,
  data: PrintSamplePayload
) =>
  RestAPIClient.call<PrintSample>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths[scope]}/${id}`,
    config: { requireAuthentication: true },
    data,
  });

export const printSampleDeleteService = (scope: PrintSampleScope, id: string) =>
  RestAPIClient.call<PrintSample>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths[scope]}/${id}`,
    config: { requireAuthentication: true },
  });
